<p>ssltest works!</p>

<pre>{{ t$ | async | json }}</pre>
